module.exports = __webpack_public_path__ + "static/img/huoland-star.5daf380f.png";